import { cn } from "@/utils/cn";

export default function TableHeader({
  children,
  className,
}: {
  children: React.ReactNode;
  className?: string;
}) {
  return (
    <th
      className={cn(
        "w-27 text-left p-0 px-4 xl:py-3 text-gray-800 font-semibold",
        className
      )}
    >
      {children}
    </th>
  );
}
